import { STATIC_PATH } from '@shared/constants/ImageConstants';

export const AD_CREATION_TEXTS = {
    TITLE: 'Ad Test Opportunity',
    AD_DESCRIPTION: 'ad description',
    BANNER_DESCRIPTION: 'Start a new ad experiment so you can try to improve your overall performance. Be'
        + 'aware that not always new tests result in a greater performance.',
    BANNER_DESCRIPTION1: 'Start a new ad experiment so you can try to improve your overall performance. Be '
        + 'aware that not always new tests result in a greater performance. ',
    BANNER_DESCRIPTION2: 'Do it now and save up to 30 minutes.',
    BUDGET: 'budget',
    CAMPAIGN_TITLE: 'banner experiment',
    CAMPAIGN_SUBTITLE: 'Only 10% improvement may result in :newConversions conversions annually',
    CAMPAIGN_TYPE: 'campaign',
    CAMPAIGN_AD_GROUP: 'ad group',
    CREATE_BUTTON: 'publish campaign',
    DESTINY_URL: 'Destiny URL*',
    DESCRIPTION: 'Description',
    DESCRIPTION1: 'Description 1*',
    DESCRIPTION2: 'Description 2',
    DESCRIPTION3: 'Description 3',
    DOMAIN: 'domain',
    HEADLINE: 'Headline',
    HEADLINE1: 'Headline 1*',
    HEADLINE2: 'Headline 2*',
    HEADLINE3: 'Headline 3',
    KEYWORDS: 'Keywords',
    ORIGINAL_AD: 'Original Ad',
    PLACEHOLDER: 'Edit here...',
    SECTION_KEYWORDS_TITLE: 'Yours users are searching for...',
    SECTION_CURRENT_AD_TITLE: 'Your current ad is',
    SECTION_COMPETITORS_AD_TITLE: 'Ads from your competitors',
    SECTION_COMPETITORS_AD_SUBTITLE: 'Here you have some ad examples from your competitors.',
    SECTION_CREATE_AD_TITLE: 'Create a new ad now',
    STATISTICAL_EXPERIMENT: 'Statistical Experiment',
    VARIATION: 'Variation',
    REQUIRED_FIELD: '* Required field',
    DEFAULT_AD_VALUES: {
        headLinePart1: 'Header 1',
        headLinePart2: 'Header 2',
        headLinePart3: 'Header 3',
        creativeFinalUrls: 'https://EXAMPLE.com/',
        description1: 'Description 1. Description 2.',
    },
    INVALID_URL: 'Invalid URL. Example: https://pareto.io',
    EMPTY_URL: 'Destiny URL is required.',
    EMPTY_HEADLINE_1: 'Headline 1 is required.',
    EMPTY_HEADLINE_2: 'Headline 2 is required.',
    EMPTY_DESCRIPTION_1: 'Description 1 is required.',
    FORM_ERROR: 'The card form has errors. Check if all required fields are correctly filled.',
    TEST_ID: {
        COMPETITORS_ADS: 'ad-creation-competitors-ads',
        CURRENT_AD: 'ad-creation-current-ad',
        KEYWORDS: 'ad-creation-keywords',
        DESTINY_URL: 'ad-creation-destiny-url-test-id',
        HEADLINE_1: 'ad-creation-headline-1-test-id',
        HEADLINE_2: 'ad-creation-headline-2-test-id',
        DESCRIPTION_1: 'ad-creation-description-1-test-id',
        CAMPAIGN_NAME: 'campaign-name-test-id',
        ADGROUP_NAME: 'adgroup-name-test-id',
    },
};

export const AD_CREATION_BACKGROUND_IMAGE = `${STATIC_PATH}/unsplash/unsplash_202011051705.png`;
